import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import CatalogView from "@/components/feature/CatalogView";
import { useSeo } from "@/hooks/useSeo";

export default function TvPage() {
  useSeo({
    title: "电视剧 - 飘花电影网",
    description:
      "飘花电影网电视剧分类页，涵盖古装、悬疑、家庭、历史、犯罪等不同类型与年份的电视剧集，支持按集数、地区筛选，追剧更便捷。",
    keywords: "最新电视剧,电视剧大全,古装剧,悬疑剧,美剧,韩剧,飘花电影网",
  });

  return (
    <div className="flex min-h-screen flex-col bg-background-100">
      <SiteHeader />
      <main className="flex-1">
        <CatalogView type="tv" />
      </main>
      <SiteFooter />
    </div>
  );
}